import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../services/admin.service';
import { Global } from '../../../app.global';
import { SettingsService } from '../../../authentication/services/settings.service';
import { HelperService } from '../../../shared/common/services/helper.service';
import { flashAnimation } from '../../../app.animations';
import { Constants } from '../../../shared/common/helper/constants';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
  animations: [flashAnimation],
})
export class SettingsComponent implements OnInit {
  constants = Constants;
  councilLogoType = '1'; // stores the type of the council logo image; 1 is a Base64 encoded image, 2 is a url
  councilLogoImage = ''; // represents the council logo image inside the image view box this can be either Base64 or a URL
  imageUrlLogo = ''; // represents the url to the logo image entered into the text input

  imageEncodedLogo = '';
  imageNameLogo = '';
  sizeFormatImageErrorLogo = '';

  signatureImageType = '1';
  signatureImage = ''; // represents the signature image inside the image view box this can be either Base64 or a URL
  imageUrlSignature = ''; // represents the url to the signature image entered into the text input

  imageEncodedSignature = '';
  imageNameSignature = '';
  sizeFormatImageErrorSignature = '';

  uploadStatus = '';
  imageAllowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
  signatures = [];

  spinnerVariants = [
    'spinner1',
    'spinner2',
    'spinner3',
    'spinner4',
    'spinner5',
    'spinner6',
    'spinner7',
    'spinner8',
  ];
  selectedSpinnerStyle = 'spinner3';
  initialSpinnerStyle = 'spinner3';
  spinnerSaveStatus = '';

  constructor(
    private adminService: AdminService,
    public global: Global,
    private settingsService: SettingsService,
    private helpService: HelperService
  ) {}

  ngOnInit() {
    this.getDefaultSignatures();
    this.getClientLogo();
    this.getSpinnerStyle();
  }

  getClientLogo() {
    this.settingsService.getApplicationSetting('Council.Logo').subscribe(
      (result) => {
        if (this.isBase64(result)) {
          // If result is base64, set councilLogo to 1
          this.councilLogoType = '1';
          this.councilLogoImage = result;
        } else {
          // If result is a URL, set councilLogo to 2
          this.councilLogoType = '2';
          this.imageUrlLogo = result;
          this.councilLogoImage = this.imageUrlLogo;
        }
        this.councilLogoImage = result;
      },
      (err) => {
        // Handle error
        this.councilLogoType = '1';
        this.councilLogoImage = `${this.constants.assetsPath}/img/barbour-logic-logo.png`;
      }
    );
  }

  getDefaultSignatures() {
    // set the default image
    this.signatureImageType = '1';
    this.signatureImage = `${this.constants.assetsPath}/img/icons/signature-default.png`;

    this.adminService.getDefaultSignatures().subscribe({
      next: (result) => {
        this.signatures = result;
      },
      error: (err) => {
        this.signatures = [];
      },
    });
  }

  isBase64(str: string): boolean {
    // Check if the string starts with 'data:image'
    return str.startsWith('data:image');
  }

  onSelectImageLogo(event) {
    this.readImageLogo(event.target);
  }

  onSelectImageSignature(event) {
    this.readImageSignature(event.target);
  }

  onCouncilImageUrlBlur() {
    this.councilLogoImage = this.imageUrlLogo;
  }

  onSignatureImageUrlBlur() {
    this.signatureImage = this.imageUrlSignature;
  }

  onCouncilLogoImageTypeChange() {
    if (this.councilLogoType === '1') {
    } else if (this.councilLogoType === '2') {
    }
  }

  onSignatureImageTypeChange() {
    if (this.signatureImageType === '1') {
    } else if (this.signatureImageType === '2') {
    }
  }

  onSignatureSelected(signature: any) {
    console.log('Selected row:', signature);
    // You can perform other actions based on the selected row here
  }

  readImageLogo(value: any): void {
    this.sizeFormatImageErrorLogo = '';
    this.imageNameLogo = '';
    const file: File = value.files[0];

    if (file.size > 512 * 1024) {
      this.sizeFormatImageErrorLogo = 'Image is too big. Please use a smaller one.';
      return;
    } else if (this.imageAllowedTypes.indexOf(file.type) === -1) {
      this.sizeFormatImageErrorLogo = 'This image format is not allowed.';
      return;
    }

    const myReader: FileReader = new FileReader();
    myReader.onloadend = (e) => {
      this.imageEncodedLogo = myReader.result.toString();
      this.councilLogoImage = this.imageEncodedLogo;
      this.imageNameLogo = file.name;
    };
    myReader.readAsDataURL(file);
  }

  readImageSignature(value: any): void {
    this.sizeFormatImageErrorSignature = '';
    this.imageNameSignature = '';
    const file: File = value.files[0];

    if (file.size > 512 * 1024) {
      this.sizeFormatImageErrorSignature = 'Image is too big. Please use a smaller one.';
      return;
    } else if (this.imageAllowedTypes.indexOf(file.type) === -1) {
      this.sizeFormatImageErrorSignature = 'This image format is not allowed.';
      return;
    }

    const myReader: FileReader = new FileReader();
    myReader.onloadend = (e) => {
      this.imageEncodedSignature = myReader.result.toString();
      this.signatureImage = this.imageEncodedSignature;
      this.imageNameSignature = file.name;
    };
    myReader.readAsDataURL(file);
  }

  isSubmitEnableLogo() {
    if (this.councilLogoType === '2' && this.imageUrlLogo.length > 5) {
      return true;
    } else if (
      this.councilLogoType === '1' &&
      this.imageEncodedLogo.length > 5 &&
      this.sizeFormatImageErrorLogo.length === 0
    ) {
      return true;
    }
    return false;
  }

  onSubmitCouncilLogo() {
    if (!this.isSubmitEnableLogo()) {
      return;
    }
    const mode = this.councilLogoType === '1' ? 'encoded' : 'url';
    const code = this.councilLogoType === '1' ? this.imageEncodedLogo : this.imageUrlLogo;
    this.adminService.saveCouncilImage(mode, code).subscribe(
      (result) => {
        if (result) {
          this.uploadStatus = 'added';
        } else {
          this.uploadStatus = 'error';
        }
        setTimeout(() => {
          this.uploadStatus = '';
        }, 2500);
      },
      (error) => {
        this.uploadStatus = 'error';
        setTimeout(() => {
          this.uploadStatus = '';
        }, 2500);
      }
    );
  }

  isSubmitEnableSignature() {
    if (this.signatureImageType === '2' && this.imageUrlSignature.length > 5) {
      return true;
    } else if (
      this.signatureImageType === '1' &&
      this.imageEncodedSignature.length > 5 &&
      this.sizeFormatImageErrorSignature.length === 0
    ) {
      return true;
    }
    return false;
  }

  onSubmitSignature() {
    if (!this.isSubmitEnableSignature()) {
      return;
    }
    const mode = this.signatureImageType === '1' ? 'encoded' : 'url';
    const code =
      this.signatureImageType === '1' ? this.imageEncodedSignature : this.imageUrlSignature;
    const tooltip =
      this.signatureImageType === '1' ? this.imageNameSignature : this.imageUrlSignature;
    this.adminService.saveSignature(tooltip, code).subscribe(
      (result) => {
        if (result) {
          this.getDefaultSignatures();
          this.uploadStatus = 'added';
        } else {
          this.uploadStatus = 'error';
        }
        setTimeout(() => {
          this.uploadStatus = '';
        }, 2500);
      },
      (error) => {
        this.uploadStatus = 'error';
        setTimeout(() => {
          this.uploadStatus = '';
        }, 2500);
      }
    );
  }

  deleteSignature(signatureId) {
    this.adminService.deleteSignature(signatureId).subscribe(
      (result) => {
        if (result) {
          this.removeSignatureFromList(signatureId);
          this.uploadStatus = 'deleted';
        } else {
          this.uploadStatus = 'error';
        }
        setTimeout(() => {
          this.uploadStatus = '';
        }, 2500);
      },
      (error) => {
        this.uploadStatus = 'error';
        setTimeout(() => {
          this.uploadStatus = '';
        }, 2500);
      }
    );
  }

  removeSignatureFromList(signatureId) {
    const signaturesList = this.signatures.map((signature) => signature.id);
    const signatureIndex = signaturesList.indexOf(signatureId);
    this.signatures.splice(signatureIndex, 1);
  }

  getSpinnerStyle() {
    this.settingsService.getApplicationSetting('Council.SpinnerStyle').subscribe(
      (result) => {
        this.selectedSpinnerStyle = this.spinnerVariants.includes(result) ? result : 'spinner3';
        this.initialSpinnerStyle = this.selectedSpinnerStyle;
      },
      (err) => {
        this.selectedSpinnerStyle = 'spinner3';
        this.initialSpinnerStyle = this.selectedSpinnerStyle;
      }
    );
  }

  onSelectSpinnerStyle(variant: string) {
    this.selectedSpinnerStyle = variant;
  }

  isSubmitEnableSpinnerStyle() {
    return this.selectedSpinnerStyle !== this.initialSpinnerStyle;
  }

  onSubmitSpinnerStyle() {
    if (!this.isSubmitEnableSpinnerStyle()) {
      return;
    }
    this.settingsService
      .updateAppSetting('Council.SpinnerStyle', this.selectedSpinnerStyle)
      .subscribe(
        (result) => {
          if (result) {
            this.initialSpinnerStyle = this.selectedSpinnerStyle;
            this.spinnerSaveStatus = 'added';
          } else {
            this.spinnerSaveStatus = 'error';
          }
          setTimeout(() => {
            this.spinnerSaveStatus = '';
          }, 2500);
        },
        (error) => {
          this.spinnerSaveStatus = 'error';
          setTimeout(() => {
            this.spinnerSaveStatus = '';
          }, 2500);
        }
      );
  }
}
